import { forwardRef, useEffect, useRef } from "react";
import { Controller, useFormContext } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";

import "./F2AdditionalInformation.scss";

import { Button, Label, TextArea } from "abs-ui-components";

import { callApi } from "../../../../../services/MonitoringPlanService";
import { API_ROUTES } from "../../ApiRoutes/ApiRoutes";
import { emitToasterMsg } from "../../../../../services/toasterUtility";
import AutoSave from "../../../../../common/AutoSave/AutoSave";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../Constants";

const F2AdditionalInformation = forwardRef(({ f2AdditionalInfo,vesselMstId, refetchMonitoringData }, ref) => {
    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (f2AdditionalInfo) {
            reset(prev => ({ ...prev, f2: f2AdditionalInfo }));
        }
    }, [f2AdditionalInfo, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });

    const handleSave = async (isAuto = false) => {
        const formValues = getValues("f2");
        const payload = { ...formValues };
        try {
            const f2AdditionalInformation = await callApi({
                method: "POST",
                url: API_ROUTES.F2(vesselMstId),
                data: payload,
            });
            if (f2AdditionalInformation?.isSuccess) {
                emitToasterMsg("success", "Table F.2", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, f2: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
                reset(getValues());
            }
            else {
                emitToasterMsg("error", "Table F.2", f2AdditionalInformation?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table F.2", error.errorMessage);
        }
    };

    return (
        <div className="f2-section-form mt-4">
            <MDBRow className="align-items-center mb-3">
                <MDBCol md="4">
                    <Label name={"Additional information"} bold />
                </MDBCol>
                <MDBCol md="4">
                    <Controller
                        name={`f2.additionalExplanation`}
                        control={control}
                        render={({ field }) => (
                            <TextArea
                                id={`f2_additionalInformation`}
                                className="textarea-resize"
                                value={field?.value || ""}
                                onChange={field.onChange}
                                placeholder=""
                                maxLength={1000}
                                rows={1}
                            />
                        )}
                    />
                </MDBCol>
            </MDBRow>
            <div className="text-center">
                <Button id="f2_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >Save</Button>
            </div>
        </div>
    );
});

export default F2AdditionalInformation;